import { setDoc, doc, updateDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";
// import { db } from "../../firebase";
// import HelperForMetaData from "../../helpers/HelperForMetaData";
// import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const storeCampaign = async (id, campaignData) => {
  try {
    campaignData = { ...campaignData, bid: getLocalStorageItem("bid") };
    const campaignDocument = await doc(db, "campaign", id);
    await setDoc(campaignDocument, campaignData);
    console.log("Campaign added/updated");
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
export const updateCampaign = async (id, statusArray) => {
  try {
    const campaignDocument = await doc(db, "campaign", id);
    await setDoc(
      campaignDocument,
      { statusArray: statusArray },
      { merge: true }
    );
    console.log("Campaign added/updated");
    return true;
  } catch (error) {
    console.log(id, statusArray, error);
    return false;
  }
};

export default storeCampaign;
